<template>
  <div>
    <w-sliding-popup type="setting"  ref="slidingPopup" class="add-log-head" :title="title" width="500px" @close="close">
      <div slot="content">
        <!--단계 별 표현 코드 -->
        <el-steps :active="activeStep" finish-status="success">
          <el-step v-for="(step, index) in stepTitles" :key="index" :title="`${index + 1}.${step}`"></el-step>
        </el-steps>
        <w-alarm-info-view :isAdd="isAdd" :alarmData="alarmData" @setOriginReceiver="setOriginReceiver" @initAlarmData="initAlarmData" @increaseActiveStep="increaseActiveStep" ref="alarmInfo" v-show="activeStep === 1"/>
        <w-alarm-type-view :isAdd="isAdd" :alarmData="alarmData" @increaseActiveStep="increaseActiveStep" :eventlevelSetting="eventlevelList" ref="alarmType" v-show="activeStep === 2"></w-alarm-type-view>
        <w-alarm-info-check-view :alarmData="alarmData" :eventlevelSetting="eventlevelList" :form-datas="checkFormData" v-if="checkFormViewShow" ref="alarmInfoCheck"></w-alarm-info-check-view>
          <!--단계 별 표현 코드 -->
      </div>
      <el-row slot="footer" type="flex" justify="space-between">
        <div>
          <el-button size="large" v-show="activeStep !== 1" @click="prevStep">이전 단계</el-button>
        </div>
        <div>
          <el-button size="large" type="solid" v-if="activeStep === 3" @click="settingAlarm">저장</el-button>
          <el-button size="large" type="solid" v-else @click="nextStep">다음 단계</el-button>
          <el-button @click="close" size="large" >취소</el-button>
        </div>
      </el-row>
    </w-sliding-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty, differenceWith, isEqual, isNil } from 'lodash';
import { stringify } from 'querystring';
import msgUtil from '@/utils/message';
import eventConstants from '@/views/log-analysis/Event/js/event-constant';
import AlarmAPI from '@/api/settings/log/lms-alarm-setting';

import WAlarmInfoView from './components/AlarmInfoView';
import WAlarmTypeView from './components/AlarmTypeView';
import WAlarmInfoCheckView from './components/AlarmInfoCheckView';

export default {
  name: 'WLogAlarmSettingsPopup',
  components: {
    WAlarmInfoView,
    WAlarmTypeView,
    WAlarmInfoCheckView,
  },
  props: {
    isAdd: {
      type: Boolean,
    },
    selectAlarmData: {
      type: Object,
    },
  },
  watch: {
    selectAlarmData: {
      deep: true,
      immediate: true,
      handler() {
        if (!this.isAdd) {
          this.alarmData = this.selectAlarmData;
        }
      },
    },
    isAdd: {
      deep: true,
      immediate: true,
      handler() {
        this.title = (this.isAdd) ? '알람 추가' : '알람 수정';
      },
    },
  },
  data() {
    return {
      // 로그 필터 설정과 같이 발생 조건의 첫번째는 삭제하지 못하고 이후 추가되는것만 삭제,
      // 초기값설정은 API에서 이벤트 등급 데이터를 로드 했을때 설정하도록 함
      checkFormData: {},
      originReceiverData: [],
      activeStep: 1,
      title: '알람 추가',
      stepTitles: ['알람 정보', '조건 설정', '확인'],
      alarmData: {
        eventName: '',
        eventLabel: '',
        eventSet: [],
        eventCondition: 'pattern',
        regexFlag: 'N',
        eventValue: '',
        eventType: 'KEYWORD_COUNT',
        dataindexId: null,
        alarmReceiver: [],
        applyFlag: 'Y',
        eventConditionLabel: '',
      },
    };
  },
  computed: {
    ...mapGetters(['eventlevelList']),
    checkFormViewShow() {
      if (this.activeStep === 3) return true;
      return false;
    },
  },
  methods: {
    settingAlarm() {
      if (this.isAdd) {
        this.addAlarm();
      } else {
        this.updateAlarm();
      }
    },
    setOriginReceiver(receiverList) {
      this.originReceiverData = receiverList;
    },
    /**
     * 알람 수정 함수
     * @author leesy918
     * @return {[type]} [description]
     */
    updateAlarm() {
      if (isEmpty(this.alarmData.alarmReceiver) && this.selectAlarmData.applyFlag === 'Y') {
        this.$message(msgUtil.getRequireInfoMsg(msgUtil.action.SELECT, '수신자'));
      } else {
        const insertList = [];
        const updateList = [];
        const deleteParams = this.$refs.alarmType.getDeleteEventList();
        const changeEventData = differenceWith(this.alarmData.eventSet, this.alarmData.originEventSet, isEqual);
        const originEventData = differenceWith(this.alarmData.originEventSet, this.alarmData.eventSet, isEqual);
        if (!isEmpty(deleteParams)) {
          deleteParams.forEach((item) => {
            item.sqlType = 'delete';
          });
        }
        changeEventData.forEach((item, index) => {
          if (isNil(item.eventId)) {
            item.sqlType = 'insert';
            insertList.push(item);
          } else {
            item.sqlType = 'update';
            const originData = originEventData[index];
            item.originEventId = originData.eventId;
            item.originEventlevelId = originData.eventlevelId;
            updateList.push(item);
          }
        });
        const eventList = updateList.concat(insertList);

        const deleteReceiver = differenceWith(this.originReceiverData, this.alarmData.alarmReceiver, isEqual);
        const insertReceiver = differenceWith(this.alarmData.alarmReceiver, this.originReceiverData, isEqual);
        const receiverParams = [];
        this.setReceiverList(deleteReceiver, insertReceiver, receiverParams);

        const modifyParams = deleteParams.concat(eventList);

        const params = {
          eventId: this.alarmData.eventId,
          eventName: this.alarmData.eventName,
          applyFlag: this.alarmData.applyFlag,
          eventType: this.alarmData.eventType,
          eventCondition: this.alarmData.eventCondition,
          eventValue: this.alarmData.eventValue,
          regexFlag: this.alarmData.regexFlag,
          dataindexId: this.alarmData.dataindexId,
          modifyParams,
          receiverParams,
        };
        const queryString = stringify({
          eventId: this.selectAlarmData.eventId,
        });

        AlarmAPI.updateEventSet(queryString, params).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '알람 조건', true));
            this.$emit('loadAlarmList');
            this.close();
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '알람 조건', false));
          }
          this.deleteParams = [];
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '알람 조건', false));
          throw new Error(e);
        });
      }
    },
    /**
     * 수신자 설정
     * @author leesy918
     * @param  {[type]} deleteReceiver [description]
     * @param  {[type]} insertReceiver [description]
     * @param  {[type]} receiverParams [description]
     */
    setReceiverList(deleteReceiver, insertReceiver, receiverParams) {
      deleteReceiver.forEach((item) => {
        const receiver = {
          alarmId: this.selectAlarmData.eventId,
          sqlType: 'delete',
          receiverId: item.managerId,
        };
        receiverParams.push(receiver);
      });
      insertReceiver.forEach((item) => {
        const receiver = {
          alarmId: this.selectAlarmData.eventId,
          sqlType: 'insert',
          receiverId: item.managerId,
        };
        receiverParams.push(receiver);
      });
    },
    /**
     * 알람 데이터 초기화
     * @author leesy918
     * @return {[type]} [description]
     */
    initAlarmData() {
      this.alarmData.eventSet = [];
      this.alarmData.eventLabel = '';
      this.alarmData.eventCondition = '';
      this.alarmData.regexFlag = 'N';
      this.alarmData.dataindexId = null;
      this.alarmData.dataindexName = '';
      this.alarmData.eventValue = '';
      this.alarmData.eventConditionLabel = '';
    },
    /**
     * 팝업 스탭 증가 함수
     * @author leesy918
     * @return {[type]} [description]
     */
    increaseActiveStep() {
      if (this.activeStep === 1) {
        // 알람이 활성화 되어 있으면 수신자 체크
        if (isEmpty(this.alarmData.alarmReceiver) && this.alarmData.applyFlag !== 'N') {
          this.$message(msgUtil.getRequireInfoMsg(msgUtil.action.SELECT, '수신자'));
        } else if (this.isAdd && (this.alarmData.eventType === eventConstants.EVENT_TYPE.UNKNOWN_PATTERN || this.alarmData.eventType === eventConstants.EVENT_TYPE.STORAGE)) {
          const params = {
            params: {
              eventType: this.alarmData.eventType,
            },
          };
          AlarmAPI.checkEventType(params).then((response) => {
            if (response.data.success && response.data.data) {
              this.$message(msgUtil.getCustomMsgData('저장소, 미확인 패턴 알람은 하나만 등록할 수 있습니다.'));
            } else {
              this.$refs.alarmType.loadData();
              this.activeStep = this.activeStep + 1;
            }
          }).catch((e) => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.CHECK, '알람 종류', false));
            throw new Error(e);
          });
        } else {
          this.$refs.alarmType.loadData();
          this.activeStep = this.activeStep + 1;
        }
      } else {
        this.$nextTick(() => {
          this.activeStep = this.activeStep + 1;
        });
      }
    },
    /**
     * 이전 스탭으로 돌아가는 함수
     * @author leesy918
     * @return {[type]} [description]
     */
    prevStep() {
      this.activeStep = this.activeStep - 1;
    },
    /**
     * 다음 버튼 눌렀을 때 발생하는 함수
     * @author leesy918
     * @return {[type]} [description]
     */
    nextStep() {
      if (this.activeStep === 1) {
        this.$refs.alarmInfo.nextStep();
      } else if (this.activeStep === 2) {
        this.$refs.alarmType.nextStep();
      }
    },
    /**
     * 알람 저장 버튼 클릭 시 작동 함수
     * @author leesy918
     */
    addAlarm() {
      if (this.alarmData.eventType !== 'KEYWORD_COUNT') {
        this.alarmData.regexFlag = 'N';
      }
      const param = {
        eventName: this.alarmData.eventName,
        applyFlag: this.alarmData.applyFlag,
        eventType: this.alarmData.eventType,
        eventCondition: this.alarmData.eventCondition,
        eventValue: this.alarmData.eventValue,
        regexFlag: this.alarmData.regexFlag,
        dataindexId: this.alarmData.dataindexId,
        eventSet: this.alarmData.eventSet,
        alarmReceiver: this.alarmData.alarmReceiver,
      };
      AlarmAPI.insertLmsAlarm(param).then((responce) => {
        if (responce.data.success) {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '알람', true));

          this.close();
          this.$emit('loadAlarmList');
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '알람', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '알람', false));
        throw new Error(e);
      });
    },
    /**
     * 팝업 오픈 함수
     * @author leesy918
     * @return {[type]} [description]
     */
    open() {
      this.$refs.slidingPopup.visible = true;
      if (this.isAdd) {
        this.initAlarmData();
      }
      this.$nextTick(() => {
        this.$refs.alarmInfo.loadData();
      });
    },
    /**
     * 팝업 닫기 함수
     * @author leesy918
     * @return {[type]} [description]
     */
    close() {
      this.activeStep = 1;
      this.alarmData = {
        eventName: '',
        eventLabel: '',
        eventSet: [],
        eventCondition: 'pattern',
        regexFlag: 'N',
        dataindexId: null,
        eventValue: '',
        eventType: 'KEYWORD_COUNT',
        alarmReceiver: [],
        applyFlag: 'Y',
        eventConditionLabel: '',
      };
      this.$refs.slidingPopup.visible = false;
      this.$refs.alarmInfo.resetFields();
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Alarm/popup/LogAlarmSettingsPopup.vue